module.exports = __webpack_public_path__ + "img/page-15.ef51d198.jpg";